import axios from 'axios';
import {withoutComma} from "../../utils/calculate/Amount";

export class OrderBorrowerService {
    getOrderBorrowerList() {
        return axios.get('/appapv/getOrderBorrowerList.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data.payload);
    }

    editOrderBorrower(folio, cantidad) {
        return axios.delete('/appapv/editOrderBorrower.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: folio,
                cantidadPostura: withoutComma(cantidad)
            }
        }).then(res => res);
    }

    deleteOrderBorrower(folio) {
        return axios.delete('/appapv/deleteOrderBorrower.action', {
            headers: {
                'Content-Type': 'application/json',
            },
            params: {
                folio: folio,
            }
        }).then(res => this.getOrderBorrowerList());
    }

    insertOrderBorrower(orderBorrower, orderType) {
        return axios.post('/appapv/insertOrderBorrower.action', {},
            {
                params: {
                    idEmisora: orderBorrower.catInstrument.idEmisora,
                    cantidadPostura: withoutComma(orderBorrower.amount),
                    plazo: orderBorrower.maturity,
                    tasa: orderBorrower.rate,
                    sobreTasa: orderBorrower.surcharge,
                    precio24Hrs: orderBorrower.price ? orderBorrower.price : 0,
                    vigencia: orderType === 'today' ? 'D' : 'S',
                    premio: orderBorrower.price ? orderBorrower.price : 0,
                    fecValor: orderBorrower.valueDate,
                }
            }).then(res => res.data);
    }
}